// FR: Définit une énumération pour les chemins de navigation dans l'application.
// EN: Defines an enumeration for navigation paths in the application.

export enum NavigationPathsEnum {
    NOT_FOUND = '*',
    LOGIN = '/',
    CREATE_PASSWORD = "/create-password",
    RESET_PASSWORD = "/reset-password",
    EMAIL_VERIFICATION = "/email-verification",
    DASHBOARD = '/dashboard',

    SHOP = '/shop',
    PAYMENT = '/shop/payment',

    STOCKS = '/stocks',
    ADD_ARTICLE = '/stocks/add-article',
    MANAGE_ARTICLE = '/stocks/articles-management',
    SELLING_MANAGEMENT = '/stocks/selling-management',
    INVENTORY_MANAGEMENT = '/stocks/inventory-management',
    PROMOTION_MANAGEMENT = '/stocks/promotion-management',
    CREDITS_MANAGEMENT = '/stocks/credits-management',
    CLIENTS_MANAGEMENT = '/stocks/clients-management',

    // SETTINGS = '/parametres',
    SETTINGS = '/settings',
    SETTINGS_MY_ACCOUNT = '/settings/my-espace',
    SETTINGS_MY_ORGANISATION = '/settings/my-company',
    SETTINGS_COLLABORATORS = '/settings/collaborators',
    SETTINGS_PLANNING = '/settings/planning',
    SETTINGS_SUBSCRIPTION = '/settings/subscribtion',

}
